import { NavLink } from "react-router-dom";
import { memo } from "react";
import { TabMenuProps } from "./types";
import { classNames, transformRoute } from "helpers";
import { Routes as ContactRoutes } from "ui/modules/contacts/navigation";
import { ReactSVG } from "react-svg";

const TabMenu: React.FC<TabMenuProps> = (props) => {
  const { contactId, contactTypeId } = props;

  return (
    <>
      <div className="flex items-center border-b border-slate-200 overflow-x-auto scrollbar-hide">
        <NavLink
          to={transformRoute(ContactRoutes.ContactDetailPageRouter, {
            id: contactId,
          })}
        >
          {({ isActive }) => (
            <div
              className={classNames(
                "group flex items-center gap-2 font-semibold pl-2 pr-4 py-2 ml-3 hover:text-sky-600 whitespace-nowrap",
                isActive
                  ? "text-sky-600 border-b-2 border-b-sky-600"
                  : "text-gray-600"
              )}
            >
              <ReactSVG
                src="/media/icons/info.svg"
                className={classNames(
                  "w-5 h-5 group-hover:stroke-sky-600",
                  isActive ? "stroke-sky-600" : "stroke-slate-500"
                )}
              />
              Detalji
            </div>
          )}
        </NavLink>
     
        <NavLink
          to={transformRoute(ContactRoutes.ContactEmailSearchPageRouter, {
            id: contactId,
          })}
        >
          {({ isActive }) => (
            <div
              className={classNames(
                "group flex items-center gap-2 font-semibold pl-2 pr-4 py-2 hover:text-sky-600 whitespace-nowrap",
                isActive
                  ? "text-sky-600 border-b-2 border-b-sky-600"
                  : "text-gray-600"
              )}
            >
              <ReactSVG
                src="/media/icons/email.svg"
                className={classNames(
                  "w-5 h-5 group-hover:stroke-sky-600",
                  isActive ? "stroke-sky-600" : "stroke-slate-500"
                )}
              />
              Email adrese
            </div>
          )}
        </NavLink>
        <NavLink
          to={transformRoute(ContactRoutes.ContactPhoneSearchPageRouter, {
            id: contactId,
          })}
        >
          {({ isActive }) => (
            <div
              className={classNames(
                "group flex items-center gap-2 font-semibold pl-2 pr-4 py-2 hover:text-sky-600 whitespace-nowrap",
                isActive
                  ? "text-sky-600 border-b-2 border-b-sky-600"
                  : "text-gray-600"
              )}
            >
              <ReactSVG
                src="/media/icons/phone.svg"
                className={classNames(
                  "w-5 h-5 group-hover:stroke-sky-600",
                  isActive ? "stroke-sky-600" : "stroke-slate-500"
                )}
              />
              Telefoni
            </div>
          )}
        </NavLink>
        <NavLink
          to={transformRoute(ContactRoutes.ContactAddressSearchPageRouter, {
            id: contactId,
          })}
        >
          {({ isActive }) => (
            <div
              className={classNames(
                "group flex items-center gap-2 font-semibold pl-2 pr-4 py-2 hover:text-sky-600 whitespace-nowrap",
                isActive
                  ? "text-sky-600 border-b-2 border-b-sky-600"
                  : "text-gray-600"
              )}
            >
              <ReactSVG
                src="/media/icons/map.svg"
                className={classNames(
                  "w-5 h-5 group-hover:stroke-sky-600",
                  isActive ? "stroke-sky-600" : "stroke-slate-500"
                )}
              />
              Adrese
            </div>
          )}
        </NavLink>
        <NavLink
          to={transformRoute(ContactRoutes.ContactNoteSearchPageRouter, {
            id: contactId,
          })}
        >
          {({ isActive }) => (
            <div
              className={classNames(
                "group flex items-center gap-2 font-semibold pl-2 pr-4 py-2 hover:text-sky-600 whitespace-nowrap",
                isActive
                  ? "text-sky-600 border-b-2 border-b-sky-600"
                  : "text-gray-600"
              )}
            >
              <ReactSVG
                src="/media/icons/note.svg"
                className={classNames(
                  "w-5 h-5 group-hover:stroke-sky-600",
                  isActive ? "stroke-sky-600" : "stroke-slate-500"
                )}
              />
              Bilješke
            </div>
          )}
        </NavLink>
           {contactTypeId === "C" && (
          <NavLink
            to={transformRoute(ContactRoutes.ContactRepresentativeSearchPageRouter, {
              id: contactId,
            })}
          >
            {({ isActive }) => (
              <div
                className={classNames(
                  "group flex items-center gap-2 font-semibold pl-2 pr-4 py-2 hover:text-sky-600 whitespace-nowrap",
                  isActive
                    ? "text-sky-600 border-b-2 border-b-sky-600"
                    : "text-gray-600"
                )}
              >
                <ReactSVG
                  src="/media/icons/users.svg"
                  className={classNames(
                    "w-5 h-5 group-hover:stroke-sky-600",
                    isActive ? "stroke-sky-600" : "stroke-slate-500"
                  )}
                />
                Povezane osobe
              </div>
            )}
          </NavLink>
        )}
      </div>
    </>
  );
};

export default memo(TabMenu);
